import ProfileImageUpload from './ProfileImageUpload'

export default ProfileImageUpload
